import React, { Component } from 'react';

class TextMainFooter extends Component {
    render() {
        return (
            <div className="widget widget-text">
                <p>
                    Our mission is to build capacity in data management, analysis, and interpretation, enabling our clients to make informed, evidence-based decisions.
                </p>
                <p>
                    From survey design to advanced impact evaluation, we provide comprehensive support throughout the data lifecycle.
                </p>	
            </div>
            /* <!-- /.widget-text --> */
        );
    }
}

export default TextMainFooter;